import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const comboIncludes = ['Todo lo del Mega Pack (6 tomos + 4 bonos)', 'PLUS — Material Avanzado:', 'Nomenclatura de complejos y química de coordinación — el tema que más confunde en bachillerato técnico', 'Digital Chemistry: aplicaciones, simuladores y herramientas de inteligencia artificial para el aula de química', 'Guías de uso en clase con actividades integradas', 'Material adaptado a los 15 países del sistema'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-petrol relative" data-id="element-199">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-200"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-201">
        <div className="text-center mb-10" data-id="element-202">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-203">
            Elegí tu pack
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-204">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        {/* OFERTA 1: MEGA PACK SOLO */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-night-card border border-gold/60 rounded-3xl p-1 relative shadow-[0_0_30px_rgba(212,175,55,0.1)] mb-8" data-id="element-205">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold/90 text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs" data-id="element-206">
            🏆 Oferta principal
          </div>

          <div className="bg-night rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-207">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-208">
              Mega Pack Química en el Aula
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-209">
              Los 6 tomos + 4 bonos estratégicos listos para usar en el aula.
            </p>

            <div className="mb-6" data-id="element-210">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-211">
                USD 45,00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-212">
                <span className="text-2xl md:text-3xl text-white" data-id="element-213">Hoy:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-214">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href="https://latam.ebookemprende.shop/cart/46064407052474:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Química en el Aula',
                value: 19.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-215">
              🟡 QUIERO EL MEGA PACK
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400" data-id="element-216">
              <span className="flex items-center gap-1.5" data-id="element-217">
                <Lock size={12} className="text-success" data-id="element-218" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-219">
                <Zap size={12} className="text-success" data-id="element-220" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-221">
                <Shield size={12} className="text-success" data-id="element-222" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-223">
                <Globe size={12} className="text-success" data-id="element-224" /> Pago en tu moneda
                local
              </span>
            </div>
          </div>
        </motion.div>

        {/* OFERTA 2: MEGA PACK MAESTRO AVANZADO */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="bg-black border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-225">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-226">
            <Sparkles size={14} data-id="element-227" /> Más elegido · Mejor valor
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-228">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-229">
              Mega Pack Maestro Avanzado
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-230">
              Llevás el pack completo más el material especializado para las
              ramas más complejas que más tiempo consumen en el aula.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-231">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-232">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-233" />
                  <span data-id="element-234">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-235">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-236">
                USD 57,90
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-237">
                <span className="text-2xl md:text-3xl text-white" data-id="element-238">Hoy:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-239">
                  USD 27,90
                </span>
              </div>
            </div>

            <Button href="https://latam.ebookemprende.shop/cart/46064601563322:1" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Mega Pack Maestro Avanzado',
                value: 27.9,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-240">
              🟡 LLEVAR PACK MAESTRO AVANZADO
            </Button>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-241">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-242" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-243">
                Pagas en tu moneda local. El importe se adapta automáticamente
                al país desde donde comprás.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}